import { render, staticRenderFns } from "./PromotionEditor.vue?vue&type=template&id=76590744&scoped=true"
import script from "./PromotionEditor.vue?vue&type=script&lang=js"
export * from "./PromotionEditor.vue?vue&type=script&lang=js"
import style0 from "./PromotionEditor.vue?vue&type=style&index=0&id=76590744&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76590744",
  null
  
)

export default component.exports